import authService from './authService';
import { getApiUrl } from '@/config/apiConfig';

/**
 * 用户设置服务
 */
class UserSettingsService {
  /**
   * 获取请求头
   * @returns {Object} 请求头对象
   */
  getHeaders() {
    const token = authService.getToken();
    if (!token) {
      throw new Error('用户未登录');
    }

    // 根据接口要求，使用特定的header参数
    return {
      'Content-Type': 'application/json',
      'katoken': token,
      'req_app_id': 'LivePlugin', // 使用LivePlugin作为应用ID
      'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy', // 对应的应用密钥
      'Accept': '*/*',
      'Connection': 'keep-alive'
    };
  }

  /**
   * 获取用户设置
   * @returns {Promise<Object>} 用户设置数据
   */
  async getUserSettings() {
    try {
      console.log('开始获取用户设置...');

      // 调用真实接口
      const response = await fetch(getApiUrl('USER_SETTINGS'), {
        method: 'GET',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        throw new Error(`获取用户设置失败: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('用户设置接口响应:', result);
      return result;
    } catch (error) {
      console.error('获取用户设置失败:', error);
      
      // 返回错误格式的响应，保持与接口一致
      return {
        success: false,
        errCode: 'FETCH_ERROR',
        errMessage: error.message || '获取用户设置失败',
        data: null
      };
    }
  }

  /**
   * 更新用户设置
   * @param {Object} settingsData 用户设置数据
   * @returns {Promise<Object>} 更新结果
   */
  async updateUserSettings(settingsData) {
    try {
      console.log('开始更新用户设置:', settingsData);

      // 注意：这里假设更新接口也是使用相同的URL，但实际可能是POST或PUT请求
      // 根据实际接口文档调整
      const response = await fetch(getApiUrl('USER_SETTINGS'), {
        method: 'POST', // 或者 PUT，根据实际接口文档
        headers: this.getHeaders(),
        body: JSON.stringify(settingsData)
      });

      if (!response.ok) {
        throw new Error(`更新用户设置失败: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('更新用户设置接口响应:', result);
      return result;
    } catch (error) {
      console.error('更新用户设置失败:', error);
      
      return {
        success: false,
        errCode: 'UPDATE_ERROR',
        errMessage: error.message || '更新用户设置失败',
        data: null
      };
    }
  }
}

export default new UserSettingsService();